import React, { useEffect, useState } from 'react';
import FaqItem from './FaqItem';
import './Faq.css';
import FaqImg from '../../../../../assets/Faq.svg';
import { fetchRadixFaqs } from '../../../../../services/radix/radixServices';

const Faq = ({ Faqs }) => {
  const [openIndex, setOpenIndex] = useState(null);
  const [faqData,setFaqdata]=useState([]);
  // Default FAQ data
  useEffect(()=>{
    const loadFaqData=async()=>{
      const data=await fetchRadixFaqs();
      setFaqdata(data);
    }
    loadFaqData();
  },[])
  
  
  const handleToggle = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="faq-container">
      <h2 className="faq-title">
        <img className="faq-img" src={FaqImg} alt="FAQ Icon" />FAQs
      </h2>
      {faqData.map((faq) => (
        <FaqItem
          key={faq.documentId}
          index={faq.id}
          question={faq.Question}
          answer={faq.Answer}
          isOpen={openIndex === faq.id}
          onToggle={handleToggle}
        />
      ))}
    </div>
  );
};

export default Faq;
